import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 80%;
  color: #000;
  margin: 0 auto 10px;
`;

export const Center = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: ${props => (props.space ? "space-between" : "center")};
`;

export const ContainerPaginate = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`;

export const InputSearch = styled.div`
  width: 100%;
  margin: 10px auto;

  button {
    background-color: var(--color-primary);
    border: none;
    padding: 5px 20px;
    cursor: pointer;
    color: #fff;
    margin-left: 5px;
    border-radius: 5px;

    &:hover {
      background-color: var(--color-primary-dark);
    }
  }
`;
